import React from 'react';
import DisabledWrapper from "@/components/DisabledWrapper";
import {r} from "@/utils/responsive";

interface EditorBlurShapesProps extends React.HTMLAttributes<HTMLDivElement> {
}

const EditorBlurShapes: React.FC<EditorBlurShapesProps> = ({className, ...props}) => {
    return (
        <DisabledWrapper style={{
            zIndex: 2,
            mixBlendMode: 'plus-lighter',
            opacity: .6
        }}>
            <svg style={{
                position: 'absolute',
                width: r.vmax(1075),
                height: r.vmax(1152),
                left: r.vmax(-341),
                bottom: r.vmax(-397),
                filter: `blur(${r.vmax(140)})`,
            }} viewBox="0 0 1075 1152" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M1074.35 911.942C1074.35 1044.21 823.353 1151.44 150.353 1151.44C-137.663 1151.44 66.3265 200.298 136.446 88.1412C347.445 -249.359 284.446 483.141 433.446 710.641C727.946 801.641 1074.35 779.67 1074.35 911.942Z"
                        fill="#5282FF" fillOpacity="0.9"/>
                </g>
            </svg>
            <svg style={{
                position: 'absolute',
                width: r.vmax(1075),
                height: r.vmax(1152),
                left: r.vmax(-411),
                top: r.vmax(-539),
                filter: `blur(${r.vmax(410)})`
            }} viewBox="0 0 1075 1152" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M1074.35 240.199C1074.35 107.927 823.353 0.699341 150.353 0.699341C-137.663 0.699341 66.3265 951.843 136.446 1064C347.445 1401.5 284.446 669 433.446 441.5C727.946 350.5 1074.35 372.472 1074.35 240.199Z"
                        fill="#85A7FF" fillOpacity="0.9"/>
                </g>
            </svg>
            <svg style={{
                position: 'absolute',
                width: r.vmax(1075),
                height: r.vmax(1152),
                bottom: r.vmax(-487),
                right: r.vmax(-366),
                filter: `blur(${r.vmax(410)})`
            }} viewBox="0 0 1075 1152" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M0.749023 911.942C0.749023 1044.21 251.749 1151.44 924.749 1151.44C1212.77 1151.44 1008.78 200.298 938.657 88.1412C727.657 -249.359 790.657 483.141 641.657 710.641C347.157 801.641 0.749023 779.67 0.749023 911.942Z"
                        fill="#5282FF" fill-opacity="0.9"/>
                </g>
            </svg>
            <svg style={{
                position: 'absolute',
                width: r.vmax(1075),
                height: r.vmax(1152),
                top: r.vmax(-439),
                right: r.vmax(-406),
                filter: `blur(${r.vmax(290)})`
            }} viewBox="0 0 1075 1152" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M0.749023 240.199C0.749023 107.927 251.749 0.699341 924.749 0.699341C1212.77 0.699341 1008.78 951.843 938.657 1064C727.657 1401.5 790.657 669 641.657 441.5C347.157 350.5 0.749023 372.472 0.749023 240.199Z"
                        fill="#5282FF" fillOpacity="0.9"/>
                </g>
            </svg>
            <svg style={{
                position: 'absolute',
                width: r.vmax(1075),
                height: r.vmax(1152),
                top: r.vmax(-439),
                right: r.vmax(-376),
                filter: `blur(${r.vmax(140)})`
            }} viewBox="0 0 1075 1152" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M0.749023 240.199C0.749023 107.927 251.749 0.699341 924.749 0.699341C1212.77 0.699341 1008.78 951.843 938.657 1064C727.657 1401.5 790.657 669 641.657 441.5C347.157 350.5 0.749023 372.472 0.749023 240.199Z"
                        fill="#5282FF" fillOpacity="0.9"/>
                </g>
            </svg>

        </DisabledWrapper>
    );
};

export default EditorBlurShapes;
